import React from 'react';

import Text from 'components/shared/Typography/Text';

import s from './index.module.css';

function SubTitle({ text }) {
  return (
    <Text className={s.subTitle} italic>
      {text}
    </Text>
  );
}

export default SubTitle;
